import Ws from "../../providers/Ws"
import LocalStorage from "../../providers/LocalStorage"

export default class DrepturiAcces {
	
	constructor(){
		this.getDrepturi()
	}


	accesAplicatie= {


		id_utilizator:-1,

		profil_selectat:'xxx',

		acces_rapoarte:true,
		acces_setari: true,
		acces_utilizatori : true,

		acces_extins_proiecte : true,

		acces_evaluari : true,
		can_edit_evaluari : true,

		acces_monitorizare : true,
		can_edit_monitorizare : true,

		sterge_proiecte: false
	}

	accesProiecte= [] // typeOf accesProiectIndividual

	accesProiectIndividual= {
			
			id_proiect:-1,
			vede_financiar: true,
			edit_financiar : true,

			vede_toate_taskurile : true, 
			editeaza_taskuri : true, 

			vede_toate_etapele : true, 
			editeaza_etape : true, 

			gestioneaza_useri : true, 

			poate_sterge_proiect: false
	}





	getAccesProiect = idProiect =>{
		return this.accesProiecte.filter(p => p.id_proiect ==idProiect)[0]
	}


	getDrepturiAplicatie = ()=>{

		console.log(' this.accesAplicatie :>> ',  this.accesAplicatie);
		return this.accesAplicatie
    }
    

    getAccesProiecte = () =>{
        return this.accesProiecte
    }


	getDrepturi = async ()=>{
	
		const WS = new Ws()
        const localUserData = new LocalStorage().GetUserData().InfoUser
		

        console.log('localUserData :>> ', localUserData);
        
        let _user = WS.customSelect('select * from useri where id = @p1' , {
            p1:localUserData.IdUser
        })

        let _drepturi = WS.customSelect('select * from useri_drepturi where id_utilizator = @p1' ,{
            p1:localUserData.IdUser
        })

        let _proiecteDrepturi = WS.customSelect('select * from proiecte_drepturi where id_utilizator = @p1',{
            p1:localUserData.IdUser
        })
	
		let _proiecte = WS.customSelect(`select * from proiecte where isnull(sters,0) = @p1 order by id desc`,{
            p1:0
        })

        let [ user,proiecte, drepturiAplicatie, drepturiProiecte ] = await Promise.all([_user, _proiecte, _drepturi, _proiecteDrepturi])
        
        // console.log('drepturiProiecte :>> ', drepturiProiecte);

		console.log('drepturiAplicatie :>> ', drepturiAplicatie);


		this.mapDrepturi(  user.Content[0], proiecte.Content, drepturiAplicatie.Content[0], drepturiProiecte.Content ) 
	}


	mapDrepturi = (user, proiecte, drepturiAplicatie, drepturiProiecte ) =>{
		let accesRightsApplicatie = {...this.accesAplicatie}
        
        
        let keyUserIndv = ['id_utilizator','profil_selectat']

		if(user.is_admin){
				for(let k in accesRightsApplicatie){

                    if(keyUserIndv.indexOf(k) === -1){
                        accesRightsApplicatie[k] = true
                    }else{
                        accesRightsApplicatie[k] = drepturiAplicatie[k]
                    }
       
				
				}
		}
		else{
			for(let k in accesRightsApplicatie){
                // console.log('accesRightsApplicatie :>> ', accesRightsApplicatie);
                if(keyUserIndv.indexOf(k) === -1){
                    accesRightsApplicatie[k] = drepturiAplicatie[k] == 1
                }else{
                    accesRightsApplicatie[k] = drepturiAplicatie[k]
                }
				
				}
        }
        
        // console.log('accesRightsApplicatie :>> ', accesRightsApplicatie);

		
		let accesRightsPeProiecte = []
		
		let keyTratateIndividual = ['id_proiect','poate_sterge_proiect','asignat_de_user_id','asignat_la_data', 'id', 'id_utilizator', 'sters'] 

		for( let p in proiecte ){

            console.log('p :>> ', p);

			let drepturiProiect = {...this.accesProiectIndividual}

            drepturiProiect.id_proiect = proiecte[p].id
            






				if(user.is_admin || drepturiAplicatie.acces_extins_proiecte == 1){

                    console.log('here 1:>> ');
					
					for(let k in drepturiProiect){

						if(keyTratateIndividual.indexOf(k) === -1 ){
							drepturiProiect[k] = true
						}
                    }
                    
                    if(drepturiAplicatie.sterge_proiecte == 1){
                        drepturiProiect['poate_sterge_proiect'] = true
                    }
                    
                    accesRightsPeProiecte.push(drepturiProiect)

				}

				else{

                    console.log('here2 :>> ');

            

                    let _drepturiPeProiect = drepturiProiecte.filter( pp => pp.id_proiect ==  proiecte[p].id )
                    
                    console.warn('_drepturiPeProiect :>> ', _drepturiPeProiect);

					if(_drepturiPeProiect.length > 0 ){

						let drepturiPeProiect = _drepturiPeProiect[0]
					
					
						for(let k in drepturiPeProiect){

							if(keyTratateIndividual.indexOf(k) === -1 ){
								drepturiPeProiect[k] = drepturiPeProiect[k] == 1  
                            }
                            
                            if(drepturiAplicatie.sterge_proiecte == 1){
                                drepturiPeProiect['poate_sterge_proiect'] = true
                            }else{
                                drepturiPeProiect['poate_sterge_proiect'] = false
                            }
						}
                        accesRightsPeProiecte.push(drepturiPeProiect)
                    }
                    
                  
					
				}

	
		}

        // console.log('accesRightsPeProiecte :>> ', accesRightsPeProiecte);

		this.accesAplicatie = accesRightsApplicatie
		this.accesProiecte = accesRightsPeProiecte


	}
}
